export default __webpack_public_path__ + "static/media/1822.4caa2500.png";